import React from 'react';

export class SliderItem extends React.Component {
    constructor(props) {
      super(props);
    };
  
    render() {
      const itemStyle = {
        backgroundImage: `url(${this.props.url})`,
        backgroundPosition: this.props.position.x + '% ' + this.props.position.y + '%'
      };

      let copyrightTextColor = null;
      if(this.props.copyrights) {
        copyrightTextColor = this.props.copyrights.color
      };
  
      return (
        <div className={this.props.className}>
          <div className="entry-image" style={itemStyle}></div>
				  <span className={"copyright text-copyright-" + copyrightTextColor + this.props.copyrightsClass}>{this.props.copyrights && this.props.copyrights.text}</span>
        </div>
      )
    }
  }